<script>
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { Radio },
    props: {
      relatorioTecnicoProjeto: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      readonly: {
        type: Boolean,
        required: true, 
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validarDados() {
        return this.$validator.validateAll();
      },
    },
    computed: {
      validarAtividadesIniciadas() {
        if ((this.relatorioTecnicoProjeto.atividadesIniciadas === undefined) || (this.relatorioTecnicoProjeto.atividadesIniciadas === null))
          return 'required'
        else
          return '';
      },
      validarAtividadesIniciadasJustificativa() {
        if ((this.relatorioTecnicoProjeto.atividadesIniciadas === undefined) || (this.relatorioTecnicoProjeto.atividadesIniciadas === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.atividadesIniciadas === 'false')
          return 'required'

        return '';
      },
      validarProjetoAndamento() {
        if ((this.relatorioTecnicoProjeto.projetoAndamento === undefined) || (this.relatorioTecnicoProjeto.projetoAndamento === null))
          return 'required'
        else
          return '';
      },
      validarProjetoAndamentoJustificativa() {
        if ((this.relatorioTecnicoProjeto.projetoAndamento === undefined) || (this.relatorioTecnicoProjeto.projetoAndamento === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.projetoAndamento === 'false')
          return 'required'

        return '';
      },
      validarLei95894() {
        if ((this.relatorioTecnicoProjeto.lei95894 === undefined) || (this.relatorioTecnicoProjeto.lei95894 === null))
          return 'required'
        else
          return '';
      },
      validarLei95894Justificativa() {
        if ((this.relatorioTecnicoProjeto.lei95894 === undefined) || (this.relatorioTecnicoProjeto.lei95894 === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.lei95894 === 'false')
          return 'required'

        return '';
      },
      validarCronogramaCumprido() {
        if ((this.relatorioTecnicoProjeto.cronogramaCumprido === undefined) || (this.relatorioTecnicoProjeto.cronogramaCumprido === null))
          return 'required'
        else
          return '';
      },
      validarCronogramaCumpridoJustificativa() {
        if ((this.relatorioTecnicoProjeto.cronogramaCumprido === undefined) || (this.relatorioTecnicoProjeto.cronogramaCumprido === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.cronogramaCumprido === 'false')
          return 'required'

        return '';
      },
      validarPlanoOrcamento() {
        if ((this.relatorioTecnicoProjeto.planoOrcamentoCumprido === undefined) || (this.relatorioTecnicoProjeto.planoOrcamentoCumprido === null))
          return 'required'
        else
          return '';
      },
      validarPlanoOrcamentoJustificativa() {
        if ((this.relatorioTecnicoProjeto.planoOrcamentoCumprido === undefined) || (this.relatorioTecnicoProjeto.planoOrcamentoCumprido === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.planoOrcamentoCumprido === 'false')
          return 'required'

        return '';
      },
      validarNormasRespeitadas() {
        if ((this.relatorioTecnicoProjeto.normasRespeitadas === undefined) || (this.relatorioTecnicoProjeto.normasRespeitadas === null))
          return 'required'
        else
          return '';
      },
      validarNormasRespeitadasJustificativa() {
        if ((this.relatorioTecnicoProjeto.normasRespeitadas === undefined) || (this.relatorioTecnicoProjeto.normasRespeitadas === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.normasRespeitadas === 'false')
          return 'required'

        return '';
      },
      validarIntercorrencia() {
        if ((this.relatorioTecnicoProjeto.intercorrencia === undefined) || (this.relatorioTecnicoProjeto.intercorrencia === null))
          return 'required'
        else
          return '';
      },
      validarIntercorrenciaJustificativa() {
        if ((this.relatorioTecnicoProjeto.intercorrencia === undefined) || (this.relatorioTecnicoProjeto.intercorrencia === null))
          return 'required'

        if (this.relatorioTecnicoProjeto.intercorrencia === 'false')
          return 'required'

        return '';
      },
      readonlyDesFatImpacProjeto() {
        return ((this.relatorioTecnicoProjeto.aprovarDesFatImpacProjeto === 1) || this.readonly)
      },
      readonlydescricaoacoesmitigacao() {
        return ((this.relatorioTecnicoProjeto.aprovarDesMitigacaoAcoesImpactaProjeto === 1) || this.readonly)
      },
      readonlyconclusoesparciais() {
        return ((this.relatorioTecnicoProjeto.aprovarConclusoesFinais === 1) || this.readonly)
      },
      readonlyAtividadesIniciadas() {
        return ((this.relatorioTecnicoProjeto.ativIniciadaAprovada === 1) || this.readonly)
      },
      readonlyProjetoEmAndamento() {
        return ((this.relatorioTecnicoProjeto.projetoAndamentoAprovado === 1) || this.readonly)
      },
      readonlyCronogramaCumprido() {
        return ((this.relatorioTecnicoProjeto.cronogramaExecCumpridoAprovado === 1) || this.readonly)
      },
      readonlyPlanoOrcamentoCumprido() {
        return ((this.relatorioTecnicoProjeto.planoTrabalhoCumpridoAprovado === 1) || this.readonly)
      },
      readonlyNormasRespeitadas() {
        return ((this.relatorioTecnicoProjeto.normasLegaisCumpridasAprovada === 1) || this.readonly)
      },
      readonlyIntercorrencia() {
        return ((this.relatorioTecnicoProjeto.intercorrenciaAprovada === 1) || this.readonly)
      },
      readonlyLei95894() {
        return ((this.relatorioTecnicoProjeto.lei95894Aprovada === 1) || this.readonly)
      }

    },
    mounted() {
    },
  }
</script>

<template>
  <div>
    <div class="row" v-if="configuracao.descricaoFatoresImpactamProjeto">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('descricaofatoresimpactoprojeto')}">
          <label class="control-label" for="descricaofatoresimpactoprojeto">
            Descrição dos fatores que impactaram o andamento do projeto no período
          </label>

          <textarea class="form-control"
                    id="descricaofatoresimpactoprojeto"
                    v-validate="'required'"
                    data-vv-name="descricaofatoresimpactoprojeto"
                    data-vv-as="descrição do fatores impactaram projeto"
                    v-model="relatorioTecnicoProjeto.descricaoFatoresImpactoProjeto"
                    :readonly="readonlyDesFatImpacProjeto">
          </textarea>

          <p class="text-danger" v-show="errors.has('descricaofatoresimpactoprojeto')">{{ errors.first('descricaofatoresimpactoprojeto') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.descricaoAcoesMitigacao">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('descricaoacoesmitigacao')}">
          <label class="control-label" for="descricaoacoesmitigacao">
            Descrição das ações de mitigação para fatores que impactaram o andamento do projeto no período
          </label>

          <textarea class="form-control"
                    id="descricaoacoesmitigacao"
                    v-validate="'required'"
                    data-vv-name="descricaoacoesmitigacao"
                    data-vv-as="descrição das ações de mitigação..."
                    v-model="relatorioTecnicoProjeto.descricaoAcoesMitigacao"
                    :readonly="readonlydescricaoacoesmitigacao">
          </textarea>

          <p class="text-danger" v-show="errors.has('descricaoacoesmitigacao')">{{ errors.first('descricaoacoesmitigacao') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.conclusoesParciais">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('conclusoesparciais')}">
          <label class="control-label" for="conclusoesparciais">
            Conclusões parciais
          </label>

          <textarea class="form-control"
                    id="conclusoesparciais"
                    v-validate="'required'"
                    data-vv-name="conclusoesparciais"
                    data-vv-as="conclusões parciais"
                    v-model="relatorioTecnicoProjeto.conclusoesParciais"
                    :readonly="readonlyconclusoesparciais">
          </textarea>

          <p class="text-danger" v-show="errors.has('conclusoesparciais')">{{ errors.first('conclusoesparciais') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.atividadesForamIniciadas">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('atividadesIniciadas')}">
          <label class="control-label block">As atividades foram iniciadas?</label>

          <radio v-model="relatorioTecnicoProjeto.atividadesIniciadas"
                 selected-value="true"
                 v-validate="validarAtividadesIniciadas"
                 data-vv-name="atividadesIniciadas"
                 data-vv-as="atividades"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonlyAtividadesIniciadas">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.atividadesIniciadas"
                 selected-value="false"
                 v-validate="validarAtividadesIniciadas"
                 data-vv-name="atividadesIniciadas"
                 data-vv-as="atividades"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonlyAtividadesIniciadas">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('atividadesIniciadas')">{{ errors.first('atividadesIniciadas') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.atividadesForamIniciadas">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarAtividadesIniciadasJustificativa, 'has-error': errors.has('atividadesIniciadasJustificativa')}">
          <label class="control-label" for="atividadesIniciadasJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="atividadesIniciadasJustificativa"
                    v-validate="validarAtividadesIniciadasJustificativa"
                    data-vv-name="atividadesIniciadasJustificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.atividadesIniciadasJustificativa"
                    :readonly="readonlyAtividadesIniciadas">
          </textarea>

          <p class="text-danger" v-show="errors.has('atividadesIniciadasJustificativa')">{{ errors.first('atividadesIniciadasJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.projetoEmAndamento">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projetoEmAndamento')}">
          <label class="control-label block">O projeto está em andamento?</label>

          <radio v-model="relatorioTecnicoProjeto.projetoAndamento"
                 selected-value="true"
                 v-validate="validarProjetoAndamento"
                 data-vv-name="projetoEmAndamento"
                 data-vv-as="projeto em andamento?"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonlyProjetoEmAndamento">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.projetoAndamento"
                 selected-value="false"
                 v-validate="validarProjetoAndamento"
                 data-vv-name="projetoEmAndamento"
                 data-vv-as="projeto em andamento?"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonlyProjetoEmAndamento">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('projetoEmAndamento')">{{ errors.first('projetoEmAndamento') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.projetoEmAndamento">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarProjetoAndamentoJustificativa, 'has-error': errors.has('projetoEmAndamentoJustificativa')}">
          <label class="control-label" for="projetoEmAndamentoJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="projetoEmAndamentoJustificativa"
                    v-validate="validarProjetoAndamentoJustificativa"
                    data-vv-name="projetoEmAndamentoJustificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.projetoAndamentoJustificativa"
                    :readonly="readonlyProjetoEmAndamento">
          </textarea>

          <p class="text-danger" v-show="errors.has('projetoEmAndamentoJustificativa')">{{ errors.first('projetoEmAndamentoJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.cronogramaExecucaoEstaSendoCumprido">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('cronogramaCumprido')}">
          <label class="control-label block">O cronograma de execução está sendo cumprido?</label>

          <radio v-model="relatorioTecnicoProjeto.cronogramaCumprido"
                 selected-value="true"
                 v-validate="validarCronogramaCumprido"
                 type="success"
                 :inline="true"
                 data-vv-name="cronogramaCumprido"
                 data-vv-as="cronograma de execução"
                 class="margin-right-10"
                 :readonly="readonlyCronogramaCumprido">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.cronogramaCumprido"
                 selected-value="false"
                 v-validate="validarCronogramaCumprido"
                 type="success"
                 :inline="true"
                 data-vv-name="cronogramaCumprido"
                 data-vv-as="cronograma de execução"
                 class="margin-right-10"
                 :readonly="readonlyCronogramaCumprido">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('cronogramaCumprido')">{{ errors.first('cronogramaCumprido') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.cronogramaExecucaoEstaSendoCumprido">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarCronogramaCumpridoJustificativa, 'has-error': errors.has('cronogramaCumpridoJustificativa')}">
          <label class="control-label" for="cronogramaCumpridoJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="cronogramaCumpridoJustificativa"
                    v-validate="validarCronogramaCumpridoJustificativa"
                    data-vv-name="cronogramaCumpridoJustificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.cronogramaCumpridoJustificativa"
                    :readonly="readonlyCronogramaCumprido">
          </textarea>

          <p class="text-danger" v-show="errors.has('cronogramaCumpridoJustificativa')">{{ errors.first('cronogramaCumpridoJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.planoTrabalhoSendoCumprido">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('planoOrcamentoCumprido')}">
          <label class="control-label block">O plano de trabalho/orçamento está sendo cumprido?</label>

          <radio v-model="relatorioTecnicoProjeto.planoOrcamentoCumprido"
                 selected-value="true"
                 v-validate="validarPlanoOrcamento"
                 type="success"
                 :inline="true"
                 data-vv-name="planoOrcamentoCumprido"
                 data-vv-as="plano de trabalho/orçamento"
                 class="margin-right-10"
                 :readonly="readonlyPlanoOrcamentoCumprido">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.planoOrcamentoCumprido"
                 selected-value="false"
                 v-validate="validarPlanoOrcamento"
                 type="success"
                 :inline="true"
                 data-vv-name="planoOrcamentoCumprido"
                 data-vv-as="plano de trabalho/orçamento"
                 class="margin-right-10"
                 :readonly="readonlyPlanoOrcamentoCumprido">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('planoOrcamentoCumprido')">{{ errors.first('planoOrcamentoCumprido') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.planoTrabalhoSendoCumprido">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarPlanoOrcamentoJustificativa, 'has-error': errors.has('planoOrcamentoCumpridoJustificativa')}">
          <label class="control-label" for="planoOrcamentoCumpridoJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="planoOrcamentoCumpridoJustificativa"
                    v-validate="validarPlanoOrcamentoJustificativa"
                    data-vv-name="planoOrcamentoCumpridoJustificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.planoOrcamentoCumpridoJustificativa"
                    :readonly="readonlyPlanoOrcamentoCumprido">
          </textarea>

          <p class="text-danger" v-show="errors.has('planoOrcamentoCumpridoJustificativa')">{{ errors.first('planoOrcamentoCumpridoJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.normasLegaisSendoCumpridas">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('normasRespeitadas')}">
          <label class="control-label block">As normas legais e/ou regulamentares estão sendo cumpridas?</label>

          <radio v-model="relatorioTecnicoProjeto.normasRespeitadas"
                 selected-value="true"
                 v-validate="validarNormasRespeitadas"
                 type="success"
                 :inline="true"
                 data-vv-name="normasRespeitadas"
                 data-vv-as="normas respeitadas"
                 class="margin-right-10"
                 :readonly="readonlyNormasRespeitadas">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.normasRespeitadas"
                 selected-value="false"
                 v-validate="validarNormasRespeitadas"
                 type="success"
                 :inline="true"
                 data-vv-name="normasRespeitadas"
                 data-vv-as="normas respeitadas"
                 class="margin-right-10"
                 :readonly="readonlyNormasRespeitadas">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('normasRespeitadas')">{{ errors.first('normasRespeitadas') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.normasLegaisSendoCumpridas">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarNormasRespeitadasJustificativa, 'has-error': errors.has('normasRespeitadasJustificativa')}">
          <label class="control-label" for="normasRespeitadasJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="normasRespeitadasJustificativa"
                    v-validate="validarNormasRespeitadasJustificativa"
                    data-vv-name="normasRespeitadasJustificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.normasRespeitadasJustificativa"
                    :readonly="readonlyNormasRespeitadas">
          </textarea>

          <p class="text-danger" v-show="errors.has('normasRespeitadasJustificativa')">{{ errors.first('normasRespeitadasJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.houveIntecorrenciaDuranteExecucao">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('intercorrencia')}">
          <label class="control-label block">Até a presente data houve alguma intercorrência durante a execução das atividades?</label>

          <radio v-model="relatorioTecnicoProjeto.intercorrencia"
                 selected-value="true"
                 v-validate="validarIntercorrencia"
                 type="success"
                 :inline="true"
                 data-vv-name="intercorrencia"
                 data-vv-as="intercorrência"
                 class="margin-right-10"
                 :readonly="readonlyIntercorrencia">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.intercorrencia"
                 selected-value="false"
                 v-validate="validarIntercorrencia"
                 type="success"
                 :inline="true"
                 data-vv-name="intercorrencia"
                 data-vv-as="intercorrência"
                 class="margin-right-10"
                 :readonly="readonlyIntercorrencia">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('intercorrencia')">{{ errors.first('intercorrencia') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.houveIntecorrenciaDuranteExecucao">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarIntercorrenciaJustificativa, 'has-error': errors.has('intercorrenciaJustificativa')}">
          <label class="control-label" for="intercorrenciaJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="intercorrenciaJustificativa"
                    v-validate="validarIntercorrenciaJustificativa"
                    data-vv-name="intercorrenciaJustificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.intercorrenciaJustificativa"
                    :readonly="readonlyIntercorrencia">
          </textarea>

          <p class="text-danger" v-show="errors.has('intercorrenciaJustificativa')">{{ errors.first('intercorrenciaJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.lei895894SendoCumprida">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('lei95894')}">
          <label class="control-label block">A lei 8.958/94 está sendo cumprida?</label>

          <radio v-model="relatorioTecnicoProjeto.lei95894"
                 selected-value="true"
                 v-validate="validarLei95894"
                 data-vv-name="lei95894"
                 data-vv-as="lei 8.958/94 está sendo cumprida?"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonlyLei95894">
            Sim
          </radio>
          <radio v-model="relatorioTecnicoProjeto.lei95894"
                 selected-value="false"
                 v-validate="validarLei95894"
                 data-vv-name="lei95894"
                 data-vv-as="lei 8.958/94 está sendo cumprida?"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonlyLei95894">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('lei95894')">{{ errors.first('lei95894') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.lei895894SendoCumprida">
      <div class="col-xs-12">
        <div class="form-group" :class="{'required': validarLei95894Justificativa, 'has-error': errors.has('lei95894Justificativa')}">
          <label class="control-label" for="lei95894Justificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="lei95894Justificativa"
                    v-validate="validarLei95894Justificativa"
                    data-vv-name="lei95894Justificativa"
                    data-vv-as="justificativa"
                    v-model="relatorioTecnicoProjeto.lei95894Justificativa"
                    :readonly="readonlyLei95894">
          </textarea>

          <p class="text-danger" v-show="errors.has('lei95894Justificativa')">{{ errors.first('lei95894Justificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-show="configuracao.relatTecnicoModSimplificado == 1">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="comentariosAdicionais">
            Comentários adicionais
          </label>

          <textarea class="form-control"
                    id="comentariosAdicionais"
                    v-model="relatorioTecnicoProjeto.comentariosAdicionais"
                    :readonly="readonly">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/compartilhado/FormDadosCadastrais.vue